import React from 'react'
import classNames from 'classnames'

interface IToolbarGroupTabProps {
  className?: string
  children?: React.ReactNode
}

const ToolbarGroupTab: React.FC<IToolbarGroupTabProps> = ({className, children}): React.ReactElement => {
  const css = classNames('d-flex flex-row justify-content-start w-100', className)
  return <div className={css}>{children}</div>
}

export {ToolbarGroupTab}
